import type {
	OrganizationServiceCreateExternalLinkData,
	OrganizationServiceDeleteExternalLinkData,
	OrganizationServiceGetExternalLinkListData,
	OrganizationServiceUpdateExternalLinkData,
	OrganizationServiceUpdateExternalLinkOrderData,
} from '@clients/api/organization';
import {
	OrganizationServiceService,
	type v1ExternalLink,
} from '@clients/api/organization';
import { action, makeAutoObservable, observable } from 'mobx';

export class ExternalLinkStore {
	@observable data?: v1ExternalLink[] = [];
	@observable totalCount?: number = 0;

	constructor() {
		makeAutoObservable(this);
	}

	@action
	async fetch(args: OrganizationServiceGetExternalLinkListData) {
		const res =
			await OrganizationServiceService.organizationServiceGetExternalLinkList(
				args
			);

		this.data = res.data;
		this.totalCount = res.totalCount;

		return res;
	}

	@action
	async create(args: OrganizationServiceCreateExternalLinkData) {
		const res =
			await OrganizationServiceService.organizationServiceCreateExternalLink(
				args
			);
		return res;
	}

	@action
	async update(args: OrganizationServiceUpdateExternalLinkData) {
		const res =
			await OrganizationServiceService.organizationServiceUpdateExternalLink(
				args
			);
		return res;
	}

	@action
	async updateOrder(args: OrganizationServiceUpdateExternalLinkOrderData) {
		const res =
			await OrganizationServiceService.organizationServiceUpdateExternalLinkOrder(
				args
			);
		return res;
	}

	@action
	async delete(args: OrganizationServiceDeleteExternalLinkData) {
		const res =
			await OrganizationServiceService.organizationServiceDeleteExternalLink(
				args
			);
		return res;
	}
}

export const externalLinkStore = new ExternalLinkStore();
